/*
 * $Id:: literalsSlice.js 2020/11/12 06:07 otsolka
 *
 *        . * .
 *      * RRRR  *   Copyright (c) 2012-2021 EUIPO: European Intelectual
 *     .  RR  R  .  Property Organization (trademarks and designs).
 *     *  RRR    *
 *      . RR RR .   ALL RIGHTS RESERVED
 *       *. _ .*
 *
 *  The use and distribution of this software is under the restrictions exposed in 'license.txt'
 */

import { createSlice } from '@reduxjs/toolkit';

import { setLiterals } from '../providers/TranslationProvider/TranslationProvider';
import { LITERALS_SLICE_NAME as SLICE_NAME } from './constants';

export const slice = createSlice({
    name: SLICE_NAME,
    initialState: {
        literals: false,
        loading: false,
        error: false,
    },
    reducers: {
        literals: (state, action) => {
            state.literals = action.payload;
            setLiterals(action.payload);
        },
        loading: (state, action) => {
            state.loading = action.payload;
        },
        error: (state, action) => {
            state.error = action.payload;
        },
    },
});

export const literals = (state) => state[SLICE_NAME].literals;
export const loading = (state) => state[SLICE_NAME].loading;
export const error = (state) => state[SLICE_NAME].error;
export default slice.reducer;
